// extracted by mini-css-extract-plugin
export default {"card":"QuestionCard_card__3KzR4","title":"QuestionCard_title__rFOJe","text":"QuestionCard_text__SUrx2","whyBtn":"QuestionCard_whyBtn__vfKb2"};